import { stringifyGraph } from '@/clients/http'
import { UserModel } from '@/http/models/User'

import { useFetchList } from '@/hooks/useFetchList'

import { UserHttpParams } from '@/types/http-params/UserHttpParams'
import { UserModel as UserType } from '@/types/model/User'

export interface UserFilters {
  search?: string
  status?: 'active' | 'inactive' | 'suspended'
}

interface UseFetchUsersProps {
  sort?: string | null
}

export const useFetchUsers = ({ sort }: UseFetchUsersProps = {}) => {
  return useFetchList<UserFilters, UserType.User, {}, any, typeof UserModel.getList>({
    pageSize: 10,
    initialFilters: {
      search: '',
      status: undefined,
    },
    fetchFunction: UserModel.getList,
    sort,
    buildQueryParams: (filters): Partial<UserHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        roles: {
          '*': true,
        },
        image: {
          path: true,
          versions: true,
        },
      }),
    }),
  })
}
